<template>
   <div id="app" class="app">
      <!-- <div v-if="showComponent"> -->
        <!-- <transition name="fade"> -->

          <router-view/>
        <!-- </transition> -->
      <!-- </div> -->
      <!-- <div v-else> -->
        <!-- <div v-loading="true"></div>
      </div> -->
  </div>
</template>

<script>
    export default {
        data() {
          return {
            showComponent: false
          };
        },
        created(){
          if((document.documentElement.clientWidth/document.documentElement.clientHeight)<1 && (730<document.documentElement.clientWidth && document.documentElement.clientWidth<=1080) ){
            this.$router.push('/magic')
          }
           this.updateWindowDimensions()
        },
        mounted(){
           window.addEventListener('resize', this.updateWindowDimensions);
           
        },
        
        methods:{
          updateWindowDimensions() {
            if( (document.documentElement.clientWidth/document.documentElement.clientHeight)<1 && (730<document.documentElement.clientWidth && document.documentElement.clientWidth<=1080)){
              this.$router.push('/magic')
            }else{
              if(this.$route.path!='/login'){
                this.$router.push('/')
              }
              
            }
            if( document.documentElement.clientWidth/document.documentElement.clientHeight  <1){
              if(this.$store.state.routerpath=='/proser'){
                this.$store.commit('mdnavaction',1)
              }else if(this.$store.state.routerpath=='/hr'){
                this.$store.commit('mdnavaction',2)
              }else if(this.$store.state.routerpath=='/cases'){
                this.$store.commit('mdnavaction',3)
              }else if(this.$store.state.routerpath=='/horecruitmentme'){
                this.$store.commit('mdnavaction',4)
              }else if(this.$store.state.routerpath=='/about'){
                this.$store.commit('mdnavaction',5)
              }else if(this.$store.state.routerpath=='/index'){
                this.$store.commit('mdnavaction',0)
              }
              if( (730<document.documentElement.clientWidth && document.documentElement.clientWidth<=1080)){
                this.$router.push('/magic')
              }else{
                this.$router.push('/')
              }
             
              // this.$router.push({ path: "/" })
            }else{
              
              if(this.$store.state.mdnavaction==1){
                this.$router.push({path:'/proser',})
              }else if(this.$store.state.mdnavaction==2){
                this.$router.push({path:'/hr',})
              }else if(this.$store.state.mdnavaction==3){
                this.$router.push({path:'/cases',})
              }else if(this.$store.state.mdnavaction==4){
                this.$router.push({path:'/horecruitmentme',})
              }else if(this.$store.state.mdnavaction==5){
                this.$router.push({path:'/about',})
              }else if(this.$store.state.mdnavaction==0){
                this.$router.push({path:'/index',})
              }
            }
          }
        },
         watch: {
          '$route'() {
            // this.showComponent = false;
            // setTimeout(() => {
            //   this.showComponent = true;
            // }, 1500); // 延迟 100 毫秒
          }
        }
    }
</script>
<style lang="less">
.app{
   -webkit-overflow-scrolling: touch; /* 启用惯性滚动 */
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
  body{
    padding:0px 0px;
    margin: 0px 0px;
  }
</style>
